/**
 *
 * @page 用户中心/账户设置/基本资料
 *
 **/

import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import BaseInfo from '&/components/BaseInfo';

function BasicInfo(props) {
    return (
        <BasePageWrap
            type="card"
            className="basic-info"
            title={intl.get('accountSetting.personalInfo')}>
            <BaseInfo />
        </BasePageWrap>
    );
}

export default BasicInfo;
